import React,{useSyncExternalStore,useEffect,useRef} from 'react';
import {outgoingSnapshot,subscribeOutgoing,settleOutgoing} from '@src/helpers/OutgoingDisplay';
import ChatMessage from '../ChatMessage/ChatMessage';
export default function OutgoingBubbles({phone,messages,templates,sender}:{phone?:string;messages:any;templates:any;sender?:any}) {
 const rows=useSyncExternalStore(subscribeOutgoing,outgoingSnapshot);
 const end=useRef<HTMLDivElement>(null);
 const ids=Object.values(messages).map((m:any)=>m.id);
 const visible=rows.filter(r=>r.phone===phone && (!r.serverId || !ids.includes(r.serverId))).sort((a,b)=>a.created-b.created);
 useEffect(()=>settleOutgoing(ids),[messages]);
 const latest=visible.length?visible[visible.length-1].id:'';
 useEffect(()=>{if(latest)end.current?.scrollIntoView({block:'end'});},[latest]);
 return <>{visible.map(r=>{
  const p=r.previewPayload || r.payload;
  const template:any=Object.values(templates).find((t:any)=>t.name===p.template?.name);
  const timestamp=String(Math.floor(r.created/1000));
  const data:any={id:r.id,from_us:true,received:false,customer_wa_id:r.phone,tags:[],chat_tags:[],sender,
   is_failed:r.state==='failed'||r.state==='uncertain',
   waba_statuses:r.state==='accepted'?{sent:timestamp}:{},
   waba_payload:{...p,id:r.id,timestamp,type:p.type || 'text',...(!p.type?{text:{body:r.fileName || 'Archivo'}}:{})}};
  return <ChatMessage key={r.id} data={data} templateData={template} localSendState={r.state} isInfoClickable={false} disableMediaPreview />;
 })}<div ref={end}/></>;
}
